//in pixels
export const LOCAL_LINKS_HEIGHT = 48;
export const LOCAL_NAV_HEIGHT = 80;
export const GLOBAL_NAV_HEIGHT = 40;
export const DISCLAIMER_BANNER_HEIGHT = 36;
export const ADMIN_TOOLBAR_HEIGHT_PX = 40;

export const PINNED_HEADER_HEIGHT_CSS_VAR = '--pinned-header-height-px';
/**
 * Height of the pinned header when fully expanded. Differs from PINNED_HEADER_HEIGHT_CSS_VAR,
 * which tracks the header's current bottom edge and shrinks while it is collapsed or hidden.
 * Scrolling up always expands the header, so offset upward scrolls by this value.
 */
export const PINNED_HEADER_FULL_HEIGHT_CSS_VAR = '--pinned-header-full-height-px';

export const MOBILE_NAV_TOOLBAR_GUTTER_SPACING = 2;
